import axiosInstanceNew from "../lib/axiosinstanceNew";

const RaiseComplains = class {

    constructor(){
        this.baseUrl="tickets";
    }

  // raise complain
  async Raise (data =[]) {
    return (await axiosInstanceNew.post(`${this.baseUrl}`,data));
  }
}

export default new RaiseComplains();